import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconContacts: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconContacts"><Path d="M19.5 21.5H4.5V19.5H19.5L19.5 2.5H4.5V19" stroke="currentColor" strokeLinecap="square"/><Path d="M13.75 8.75C13.75 9.7165 12.9665 10.5 12 10.5C11.0335 10.5 10.25 9.7165 10.25 8.75C10.25 7.7835 11.0335 7 12 7C12.9665 7 13.75 7.7835 13.75 8.75Z" stroke="currentColor"/><Path d="M11.9997 12C10.2365 12 8.77777 13.3039 8.53516 15H15.4643C15.2217 13.3039 13.7629 12 11.9997 12Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconContacts;
